module.exports = __webpack_public_path__ + "img/Content.2904289b.png";